import { z } from 'zod';
import { allHtmlParsers } from '@utils/ast';
import { bindInputWithOptionsMaker } from '../util.make-input-with-options.js';

const makeInputWithOptions = bindInputWithOptionsMaker();
const wordDropdownInput = makeInputWithOptions({
  getCorrectOption: node => {
    return node.options.find(it => it.isCorrectAnswer);
  },
  entry: {
    schema: z.object({
      type: z.literal("word-dropdown").default("word-dropdown"),
      selectedIndex: z.number().nullish().default(null)
    }),
    shouldValidate: (node, entry) => node.options.some(option => option.isCorrectAnswer) || typeof entry?.selectedIndex === "number",
    validate: (input, entry) => entry.selectedIndex != null && !!input.options[entry.selectedIndex]?.isCorrectAnswer,
    parseLegacyDetailItem: (item, context) => {
      if (context.relatedTask.taskType === "SelectAnswers" && context.relatedTask.answerType === "DropDown" && typeof item === "number") {
        const typedInput = context.relatedInput;
        if (typedInput.nodeType !== "word-dropdown-input") {
          return undefined;
        }
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "word-dropdown",
          selectedIndex: item
        }];
      }
    }
  },
  parsers: {
    worddropdown: (node, context) => {
      const inputContext = context.extra;
      const index = Array.from(node.parentElement?.children ?? []).filter(child => !Object.keys(allHtmlParsers).includes(child.tagName.toLowerCase())).indexOf(node);
      const options = (() => {
        return Array.from(node.querySelectorAll("worddropdownoption")).map((it, optionIndex) => ({
          id: optionIndex,
          label: it.textContent ?? "",
          isCorrectAnswer: it.getAttribute("correctAnswer") === "true"
        }));
      })();
      return {
        id: `${inputContext?.taskId ? `${inputContext.taskId}-` : ""}${index}`,
        nodeType: "word-dropdown-input",
        label: node.getAttribute("label") || null,
        options
      };
    }
  }
});

export { wordDropdownInput };
//# sourceMappingURL=input.word-dropdown.js.map
